// Catálogos cerrados (enums) del formulario. Centralizados aquí para que
// backend y los dos frontends siempre estén alineados — añadir un equipo
// nuevo es solo tocar este archivo.
export const TIPO_RESIDENCIA = ['Habitual', 'Esporádica'];
export const SI_NO = ['Sí', 'No'];
export const EQUIPOS_DESCALCIFICADOR = [
    'VD 7',
    'VD 8',
    'VD 12',
    'VD 18',
    'Genesis',
    'Turbical',
    'Otro',
];
export const EQUIPOS_OSMOSIS = [
    'RO Horizon C/B',
    'RO Horizon S/B',
    'RO 5 Etapas C/B',
    'RO 5 Etapas S/B',
    'RO FD',
    'Otro',
];
export const VASO_EXPANSION = ['No', 'Sí 1', 'Sí 2', 'Sí 3', 'Sí 4'];
export const LLAVE_PASO = ['No', 'Sí'];
// Lista guía de qué capturar — la PWA del técnico la muestra como
// checklist sobre las fotos/vídeos que se le piden. Cada entrada es
// orientativa, NO obligatoria — el técnico puede subir más.
export const CAPTURAS_SUGERIDAS = [
    { key: 'registros', label: 'Cuadro de registros (escritura legible)', tipo: 'foto' },
    { key: 'desague', label: 'Punto de desagüe disponible', tipo: 'foto' },
    { key: 'espacio', label: 'Espacio donde irá el equipo', tipo: 'foto' },
    { key: 'etiqueta', label: 'Etiqueta / analítica del agua', tipo: 'foto' },
    { key: 'entorno', label: 'Vídeo panorámico del entorno', tipo: 'video' },
];
//# sourceMappingURL=catalogos.js.map